export default "__VITE_ASSET__BOnPpm7h__"